<div class="offer-details-container" *transloco="let t">
  <button class="description-toggle" (click)="collapsed = !collapsed" [attr.aria-expanded]="!collapsed">
    <span>{{t('modals.sms_sub_promo_modal.offer_details')}} &nbsp;</span>
     <cwo-icon  [name]="iconNameType.arrow" class="icon" [@rotate]="collapsed" ></cwo-icon>
  </button>
  
  <div class="collapsible" [ngClass]="{ 'expanded': !collapsed }">
    <p *ngIf="!collapsed" [@expanded] class="offer-description">{{details()}}</p>
  </div>
</div>
